<template>
  <article class="sale-summary-card sale-summary-card--budget-health">
    <header class="sale-summary-card__section-title sale-summary-card__section-title--center">
      <h5>{{ text.title }}</h5>
    </header>

    <div class="sale-summary-ring" :style="ringStyle">
      <div class="sale-summary-ring__inner">
        <strong :class="ringValueClass">{{ ringDisplayLabel }}</strong>
        <small v-if="ringTotalAmount">de {{ ringTotalAmount }}</small>
      </div>
    </div>

    <div class="sale-summary-budget-health__status" :class="healthStatus.className">{{ healthStatus.label }}</div>
    <p class="sale-summary-budget-health__copy">
      {{ healthSummaryText }}
    </p>
  </article>
</template>

<script>
import { SALES_TEXT } from '@/texts/catalog/sales';

const HEALTH_CARD_TEXT = SALES_TEXT.shared.summary.businessHealthCard;

export default {
  name: 'SaleSummaryBusinessHealthCard',
  props: {
    ringPercent: {
      type: Number,
      default: 0,
    },
    marginPercent: {
      type: Number,
      default: 0,
    },
    ringMainAmount: {
      type: String,
      default: '0%',
    },
    ringTotalAmount: {
      type: String,
      default: '',
    },
    healthStatus: {
      type: Object,
      default: () => ({ label: HEALTH_CARD_TEXT.defaults.statusLabel, className: 'is-danger' }),
    },
    healthSummaryText: {
      type: String,
      default: HEALTH_CARD_TEXT.defaults.summary,
    },
    ringColor: {
      type: String,
      default: '#22c55e',
    },
  },
  data() {
    return {
      text: HEALTH_CARD_TEXT,
    };
  },
  computed: {
    isNegativeMargin() {
      return Number(this.marginPercent || 0) < 0;
    },
    ringDisplayLabel() {
      const fallback = parseFloat(String(this.ringMainAmount || '').replace('%', ''));
      const percentValue = Number.isFinite(fallback)
        ? fallback
        : Number(this.marginPercent || 0);

      const integerPercent = percentValue < 0
        ? Math.ceil(percentValue)
        : Math.floor(percentValue);

      return `${integerPercent}%`;
    },
    ringValueClass() {
      return this.isNegativeMargin
        ? 'sale-summary-ring__value--negative'
        : '';
    },
    ringStyle() {
      const percent = Number(this.ringPercent || 0);
      const color = this.isNegativeMargin
        ? '#f59e0b'
        : (String(this.ringColor || '').trim() || '#22c55e');

      return {
        background: `conic-gradient(${color} ${percent}%, #dbe2eb ${percent}% 100%)`,
      };
    },
  },
};
</script>

<style scoped>
.sale-summary-ring__inner strong {
  font-size: 24px;
}

.sale-summary-ring__value--negative {
  color: #9a3412;
}
</style>
